import { Descriptions, Divider, Space, Typography } from 'antd'
import { createStyles } from 'antd-style'

import { BizTypeTag } from '@eastcoal/shared/components/BizTypeTag'

import { TradeSessionItemFooter } from './Footer'
import { TradeSessionItemProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  container: {
    overflow: 'hidden',
    padding: token.paddingSM,
    borderRadius: token.borderRadiusSM,
    border: `1px solid ${token.colorSplit}`,
    position: 'relative'
  },
  header: {
    marginBlockEnd: token.marginSM
  },
  headline: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    gap: token.paddingXXS,
    marginBlockEnd: token.marginXXS
  },
  tag: {
    flex: 'none'
  },
  title: {
    margin: '0 !important',
    overflow: 'hidden',
    [`h5&`]: {
      fontWeight: 500
    }
  },
  secondary: {
    color: token.colorTextTertiary
  },
  footer: {
    background: token.colorBgMask,
    width: '100%',
    minHeight: 32,
    position: 'absolute',
    left: 0,
    bottom: 0
  }
}))

export const TradeSessionItem = ({ data }: TradeSessionItemProps) => {
  const {
    bizType,
    title = '',
    kindName,
    productName,
    managerName,
    managerPhone,
    startTime
  } = data
  const suffixCount = title.length - title.lastIndexOf('-') - 1
  const startText = title.slice(0, title.length - suffixCount - 1).trim()
  const suffixText = title.slice(-suffixCount).trim()

  const { styles } = useStyles()

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headline}>
          <BizTypeTag type={bizType} />
          <Typography.Title ellipsis className={styles.title} level={5}>
            {startText}
          </Typography.Title>
        </div>
        <Typography.Title ellipsis className={styles.title} level={5}>
          {suffixText}
        </Typography.Title>
      </div>
      <Descriptions
        column={1}
        size='small'
        items={[
          {
            label: '品种',
            children: kindName
          },
          {
            label: '标的物',
            children: productName
          },
          {
            label: '联系人',
            children: (
              <Space
                orientation='horizontal'
                separator={<Divider orientation='vertical' />}
              >
                <span>{managerName}</span>
                <span>
                  <span className={styles.secondary}>电话：</span>
                  <span>{managerPhone}</span>
                </span>
              </Space>
            )
          },
          {
            label: '开始时间',
            children: startTime
          }
        ]}
      />
      <TradeSessionItemFooter className={styles.footer} record={data} />
    </div>
  )
}
